module.exports = __webpack_public_path__ + "img/search.274c36c3.png";